import { addNotificationAction } from '../../../../store/notifications/actions';
import AbstractChatNotificationEventCatcher from '../../AbstractChatNotificationEventCatcher';

export default class DirectMessagesNotificationEventCatcher extends AbstractChatNotificationEventCatcher {
  static process(notificationInfo, dispatch) {
    dispatch(addNotificationAction(notificationInfo));
  }
}
